import { render, staticRenderFns } from "./player_stat.vue?vue&type=template&id=553cf506&"
import script from "./player_stat.vue?vue&type=script&lang=js&"
export * from "./player_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports